import React from 'react';
import { LadenFactorExpeditionPreviewOutDTO } from '@api/ringil-api.v2';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '@utils/priceUtils';
import useTranslationLgs from '@hooks/i18n/useTranslation';

interface AcceptedSummaryProps {
  childExpeditions?: LadenFactorExpeditionPreviewOutDTO[];
}

const AcceptedSummary: React.FC<AcceptedSummaryProps> = ({ childExpeditions }) => {
  const { t } = useTranslation('common');
  const { tr } = useTranslationLgs();

  if (!childExpeditions || childExpeditions.length === 0) {
    return null;
  }

  // Calculate total units
  const totalUnits = childExpeditions.reduce((sum, exp) => sum + (exp.sumManipulationUnits || 0), 0);

  // Group prices by currency
  const pricesByCurrency: { [key: string]: number } = {};
  childExpeditions.forEach(exp => {
    if (exp.price !== null && exp.price !== undefined && exp.currency) {
      pricesByCurrency[exp.currency] = (pricesByCurrency[exp.currency] || 0) + exp.price;
    }
  });

  const currencies = Object.keys(pricesByCurrency).sort();

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Accepted Units */}
        <div>
          <p className="text-sm ftext-content-secondary p-mb-2">
            {tr('AcceptedSummary.acceptedUnits', 'Accepted units')}
          </p>
          <p className="text-lg font-semibold text-content-primary">
            {totalUnits}
          </p>
        </div>

        {/* Price Summary */}
        {currencies.length > 0 && (
          <div>
            <p className="text-sm text-content-secondary p-mb-2">
              {t('AcceptedSummary.acceptedPrice', 'Accepted price')}
            </p>
            <div className="space-y-1">
              {currencies.map(currency => (
                <p key={currency} className="text-base font-semibold text-content-primary">
                  {formatPrice(pricesByCurrency[currency], currency)}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AcceptedSummary;
